import { useAlert } from 'react-alert';

import { useQueryClient } from '@tanstack/react-query';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';

import { useEditableSectionsContext } from '../../../EditableSection';
import { isAdmin } from '@uplift/utils';

type Section = 'profile' | 'billing' | 'insurance';

export const useUpdateSettings = (section: Section, userId?: string) => {
  const l10n = useL10n();
  const currentUser = useCurrentuser();
  const { setEditKey } = useEditableSectionsContext();
  const queryClient = useQueryClient();
  const alert = useAlert();
  const isUserAdmin = isAdmin(currentUser);

  const onFormSubmitSuccess = async (message?: string) => {
    alert.success(message ?? l10n.accountSettings.changesUpdatedSuccessfully);
    setEditKey(null);
    if (section === 'profile') {
      await queryClient.invalidateQueries([ 'user', 'userProfile', currentUser.id ]);
    }

    if (section === 'insurance' && isUserAdmin) {
      await queryClient.invalidateQueries([ 'archivedInsurances', userId ]);
    }
  };

  const onFormSubmitError = (message?: string) => {
    alert.error(message ?? l10n.accountSettings.changesCouldNotBeSaved);
  };

  return { onFormSubmitSuccess, onFormSubmitError };
};
